import './style/index.js';

import _Action from './action';

export const ChatAction = _Action;
export default ChatAction;

export * from './type.js';
